module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO22CalculadoraPresupuestoa (53).13bb723.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO22CalculadoraPresupuestoa (53).mp4
// module id = 748
// module chunks = 1